import type { FieldValues, Path, PathValue, UseFormReturn } from 'react-hook-form';
import { slugify } from '@/lib/schemas';

export function useSlugSync<T extends FieldValues & { slug: string }>(
  form: UseFormReturn<T>,
  slugifier: (name: string) => string = slugify,
) {
  return (value: string, fieldOnChange: (v: string) => void) => {
    fieldOnChange(value);
    const isDirtySlug = (form.formState.dirtyFields as Record<string, unknown>).slug;
    if (!isDirtySlug) {
      const slug = slugifier(value);
      form.setValue('slug' as Path<T>, slug as PathValue<T, Path<T>>, {
        shouldValidate: slug.length > 0,
      });
    }
  };
}
